import Cookies from "js-cookie";
import { on } from "../utils/listeners";

const storeAlert = () => {
  const modal = document.querySelector("#change-store-modal");
  if (modal) {
    analytics.track("Store Redirect Modal Shown", {
      store:
        window.countryCode === ""
          ? "GB"
          : window.countryCode.replace("/", "").toUpperCase()
    });
  }

  on("click", ".js-switch-store", el => {
    Cookies.set("preferredStore", el.dataset.storeCode, {
      expires: 365
    });
  });
};

export default storeAlert;
